<template>
    <v-container
            class="fill-height"
            fluid
    >
        <v-snackbar v-model="snackbar.visible"
                    :timeout="snackbar.timeout"
                    :color="snackbar.color"
                    top>
            {{snackbar.text}}
        </v-snackbar>
        <v-row
                align="center"
                justify="center"
        >
            <v-col
                    cols="12"
                    sm="8"
                    md="4"
            >
                <v-card class="elevation-12">
                    <v-toolbar
                            color="primary"
                            dark
                            flat
                    >
                        <v-toolbar-title>Passwort zurücksetzen</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-form
                                ref="resetForm"
                        >
                            <v-text-field
                                    label="Email Adresse"
                                    name="email"
                                    :rules="emailRules"
                                    prepend-icon="person"
                                    type="text"
                                    v-model="email"
                                    @keypress="keypress"
                            />
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="primary" @click="reset" :loading="loading">Password zurücksetzen</v-btn>
                    </v-card-actions>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import {accountService} from "../services/accountService";
    export default {
        name: "Forgot",
        data() {
            return {
                email: "",
                emailRules: [
                    v => !!v || 'E-mail wird benötigt',
                    v => /.+@.+\..+/.test(v) || 'Keine gültige E-Mail Adresse',
                ],
                snackbar: {
                    visible: false,
                    text: "",
                    timeout: 5000,
                    color: ""
                },
                loading: false
            }
        },
        methods: {
            keypress(event) {
                if(event.key === "Enter")
                    this.reset()
            },
            reset() {
                if(!this.$refs.resetForm.validate())
                    return;
                this.loading = true;
                let self = this;
                accountService.forgotPassword(this.email).then(() => {
                    self.loading = false;
                    self.email = ""
                    self.snackbar.visible = true;
                    self.snackbar.text = "Link zum zurücksetzen des Passworts wurde gesendet!"
                    self.snackbar.color = "success";
                }).catch(() => {
                    self.loading = false;
                    self.snackbar.visible = true;
                    self.snackbar.text = "Ein Fehler ist aufgetreten"
                    self.snackbar.color = "error";
                })
            }
        }
    }
</script>

<style scoped>

</style>